import {ServiceType} from '../../domain/types';
import * as React from 'react';
import { useIntl } from '@/intl';
import { useService } from '@/scopes/checkout/domain/hooks';
import ServiceBox from './ServiceBox';

export function GolfService() {
  const intl = useIntl();
  const { service } = useService(ServiceType.Golf);

  if (!service) return null

  return (
    <ServiceBox
      title={intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_title' })}
      description={intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_description' })}
      glyph="IconGolfClub"
    />
  );
}
